import { EditProjectContextProps } from "../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { findByKey, findByKeys } from "../../../../Utils/arrays";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";
import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { getSpdrOrPdsrIdFromLtlPipeline } from "../../../ViewModel/LtlPipelineViewModelUtils";

type ToggleOutOfScopeProps = {
  editProjectContext: EditProjectContextProps;
  outOfScopeChecked: boolean;
  ltlPipeline: LtlPipelineViewModel;
};

export const toggleOutOfScope = ({
  editProjectContext,
  outOfScopeChecked,
  ltlPipeline,
}: ToggleOutOfScopeProps) => {
  const { project, setProject } = editProjectContext;
  const spdrOrPdsrId = getSpdrOrPdsrIdFromLtlPipeline(ltlPipeline);

  // Get pipeline instance and set IsFinished and OutOfScope values
  const spdrOrPdsrPipeline = findByKeys<LtlPipelineViewModel>({
    list: project.ltlPipelines,
    identifier: spdrOrPdsrId,
    firstKey: "SpdrId",
    secondKey: "PdsrId",
  });

  if (spdrOrPdsrPipeline) {
    spdrOrPdsrPipeline.IsFinished = outOfScopeChecked;
    spdrOrPdsrPipeline.OutOfScope = outOfScopeChecked;

    // reset routing, when Out of Scope is checked
    if (outOfScopeChecked) spdrOrPdsrPipeline.routing = [];
  }

  // Set InScope for selected PDSR or SPDR
  const pdsrOnProjectForId = findByKey<PdsrClientViewModel>({
    list: project.PdsrsOnThisProject,
    identifier: spdrOrPdsrId,
    keyOfType: "PdsrId",
  });

  const spdrOnProjectForId = findByKey<SpdrClientViewModel>({
    list: project.SpdrsOnThisProject,
    identifier: spdrOrPdsrId,
    keyOfType: "SpdrId",
  });

  if (pdsrOnProjectForId) pdsrOnProjectForId.InScope = !outOfScopeChecked;
  if (spdrOnProjectForId) spdrOnProjectForId.InScope = !outOfScopeChecked;

  setProject({ ...project });
};
